import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const OrdersDateCaseContainer = styled.div`
    font-family: AvenirNextWorld Demi;
    display: flex;
    /* width: 95%; */
    margin: 0.6rem 34px 0.625rem 0.2rem;
    color: #140f4b;

    & .today {
        font-family: AvenirNextWorld Regular;
        margin-right: 10px;
    }

    & span {
        font-family: AvenirNextWorld Regular;
    }

    ${media.smalDevice`
        margin: 0.6rem 25px 0.625rem 0.2rem ;
    `}
    ${media.mobileDevice`
        margin: ${(props) =>
            props.today
                ? '0.5rem 1rem 0.625rem 1rem'
                : '1.5rem 1rem 0.625rem 1rem'};
        flex-direction: column;
        width:auto;
        & .today{
            font-family: AvenirNextWorld Regular;
            margin: 0;
         }

        & span {
            font-family: AvenirNextWorld Regular;
        }
    `}
`;

export const DateCaseContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .cases {
        color: #4f4f4f;
        font-size: 14px;
    }
`;

export const SearchContainer = styled.div`
    margin: 10px 0;
    display: none;

    ${media.mobileDevice`
        display: block;
    `}
`;
